import { documentsVisibilityColumns } from '@documents/components/DocumentsDataTable/visibilityColumns';

import { type DataSetConfig } from '../types';

const initialDocumentsConfig: DataSetConfig = {
  sorting: [{ field: 'dueDate', order: 'desc' }],
  pagination: { pageSize: 20, pageIndex: 0 },
  columnsVisibility: documentsVisibilityColumns,
};

export { initialDocumentsConfig };
